<template>
  <div v-if="maxFiles > (files?.length || 0)" class="w-100" @drop="drop" @dragenter="dragEnter" @dragleave="dragLeave">
    <label class="file-loader-area" for="formFile" @dragover="handleDragOver" aria-label="Área de upload de arquivos.">
      <div class="file-loader-area__icon">
        <img class="icon" src="../../assets/img/icon-upload.svg" style="width: 53px; height: 60px;" />
      </div>
      <div class="file-loader-area__text" v-if="!isDragging"><strong class="link-upload-area">
          Clique para inserir</strong> ou arraste e solte os documentos
        <div class="file-loader-area__file-spec">{{ messageLoadArea }}</div>
      </div>

      <div class="file-loader-area file-dragging" v-else>
        <div class="file-loader-area__text"></div><strong>Solte os documentos aqui!</strong>
      </div>
    </label>
    <input class="d-none" id="formFile" ref="file" type="file" @input="onChange" :accept="accept" multiple="multiple" />
  </div>
  <div class="container-fluid mt-2 p-1">
    <div class="row" v-if="files.length">
      <div class="col-xl-6 col-lg-6 col-md-12 p-2" v-for="file in files" :key="file.name">
        <div class="loaded-file" :class="[!!isInvalid(file.type) ? 'loaded-file--error' : '']">
          <div class="loaded-file__icon">
            <i class="icon fa-regular fa-file-lines"></i>
          </div>
          <div class="loaded-file__content">
            <div class="loaded-file__name">{{ file.name }}</div>
            <div class="loaded-file__error">{{ isInvalid(file.type) }}</div>
            <div :class="[!!isInvalid(file.type) ? 'progress-bar-error' : 'progress-bar']"></div>
          </div>
          <div class="loaded-file__action" @click="remove(files.indexOf(file))">
            <i class="icon fa-regular fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UploadComponent',
  components: {},
  data: () => ({
    isDragging: false,
    files: [],
    progress: 0
  }),
  updated() {
    setTimeout(() => {
      this.progress = 100;
    }, 1000);
  },
  props: {
    filesUpload: {
      required: true
    },
    accept: {
      type: String,
      default: ".csv",
    },
    messageLoadArea: {
      type: String,
      default: 'Arquivos com no máximo 25mb'
    },
    maxFiles: {
      type: Number,
      default: 5
    }
  },
  methods: {
    onChange() {
      this.progress = 0;

      if (this.files.length > 0) {
        this.files = [...this.files, ...this.$refs.file.files];
      } else {
        this.files = [...this.$refs.file.files];
      }

      this.$emit('update:filesUpload', this.files);
    },
    remove(index) {
      this.files.splice(index, 1);
    },
    dragEnter(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragLeave() {
      this.isDragging = false;
    },
    isInvalid(item) {
      return item !== 'text/csv' ? 'Importar documento em CSV' : '';
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    handleDragOver(event) {
      event.preventDefault();
    },
  },
});
</script>

<style scoped>
.file-dragging {
  border-color: var(--color-primary) !important;
  border-width: 2px;
  color: var(--color-primary) !important;
  background-color: var(--color-grayscale-light);
  opacity: 0.4;
}

.loaded-file {
  width: 100%;
}

.loaded-file__content {
  max-width: calc(100% - 4em)
}

.loaded-file__action {
  cursor: pointer;
}

label {
  cursor: pointer;
  width: 100%;
}

.link-upload-area:hover {
  text-decoration: underline;
}

.progress-bar {
  width: 0%;
  background-color: var(--color-primary);
  display: flex;
  animation: loading 1.2s ease-in-out forwards;
  animation-delay: 0s;
  border-radius: 10px;
}

.progress-bar-error {
  width: 0%;
  background-color: var(--color-danger);
  display: flex;
  animation: loading 1.2s ease-in-out forwards;
  animation-delay: 0s;
  border-radius: 10px;
}

.loaded-file__name {
  max-width: 25ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes loading {
  0% {
    width: 10%;
    height: 0.3em;
    margin-top: 2%;
    visibility: visible;
  }

  99% {
    height: 0.3em;
    width: 100%;
    margin-top: 2%;
  }

  100% {
    /**reset */
    visibility: hidden;
    height: 0px;
    margin-top: 0px;
  }
}
</style>
